import { Column, DataTable } from "@/components";
import { IMaterial } from "@/config/models/materials.types";
import { useGetAllMaterials } from "@/config/services/useGetAllMaterials";

import { MaterialActions } from "./MaterialActions";

export function MaterialsList() {
  const { data, isFetching } = useGetAllMaterials();

  return (
    <DataTable
      dataKey="id"
      loading={isFetching}
      paginator={false}
      scrollHeight="flex"
      value={data ?? []}
    >
      <Column field="name" header="Material" />
      <Column
        frozen
        alignFrozen="right"
        body={(row: IMaterial) => <MaterialActions material={row} />}
        style={{ width: "50px" }}
      />
    </DataTable>
  );
}
